<script>
export default {
    props: {
        path: Array
    },
    methods: {
        goto: function (tar) {
            this.$router.push(tar)
        }
    }
}
</script>

<template>
    <div class="BreadCrumb">
        <p>当前位置：
            <template v-for="(p, index) in path" >
                <span class="touchAble" v-if="p.target" :key="p.name + 'linkspan'" @click="goto(p.target)" >{{p.name}}</span>
                <span v-else :key="p.name + 'span'" >{{p.name}}</span>
                <span :key="p.name + '>'" v-if="index != path.length - 1" > > </span>
            </template>
        </p>
    </div>
</template>

<style lang="scss" scoped>
@import '@/css/color.scss';
.BreadCrumb {
    color: #596063;
    .touchAble {
        color: #14A7D7;
        cursor: pointer;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/common/BreadCrumb.vue